import useUser from "@/api/apis";
import { fetchData, Method } from "@/utils/fetcher";
import { useMutation } from "@tanstack/react-query";

export type PlayerPlatform = "PCP" | "VRP" | "LIVE" | "MOP";

interface PlayerFeedbackBody {
  commentText: string;
  needContact: boolean;
  platform: PlayerPlatform;
}

const PlayerFeedbackPath = "/admin-api/api/v1/player-feedback/";

export function usePlayerFeedback() {
  const { token } = useUser();
  return useMutation({
    mutationFn: async (body: PlayerFeedbackBody) => {
      return await fetchData<null>({
        url: PlayerFeedbackPath,
        token: token?.token,
        method: Method.POST,
        data: body,
      });
    },
  });
}
